import { render } from "./likes.vue?vue&type=template&id=0ae0e8c0"
import script from "./likes.vue?vue&type=script&lang=js"
export * from "./likes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__